import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { InventoryAnalyticsDetailBaseBusiness } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { DetailBaseBusinessData } from '@/inventoryDashboardModule/pages/useInventoryDashboardStore/types';

/**
 * 在庫管理ダッシュボードの詳細情報(集計)を生成する
 */
export class DetailBaseBusinessDataFactory {
  /**
   * 在庫管理ダッシュボードの詳細情報(集計)を生成する
   * @param initialData - 初期情報
   */
  public static create = (initialData: Partial<InventoryAnalyticsDetailBaseBusiness> = {}): DetailBaseBusinessData => {
    const res: DetailBaseBusinessData = {
      ...BusinessFactory.create({
        ...initialData,
        businessId: initialData.baseBusinessId,
        aggregateBusinessResponsibleUsers: initialData.aggregateBusinessReponsibleUsers?.map((u) =>
          UserAccountFactory.create({ email: u.id, name: u.name })
        ),
        baseBusinessResponsibleUsers: initialData.baseBusinessResponsibleUsers?.map((u) =>
          UserAccountFactory.create({ email: u.id, name: u.name })
        ),
        forecastForReceiptResponsibleUsers: initialData.forecastForReceiptResponsibleUsers?.map((u) =>
          UserAccountFactory.create({ email: u.id, name: u.name })
        ),
      }),
      aggregateBusinessId: initialData.aggregateBusinessId,
      salesResultAmount: initialData.salesResultAmount ? Number(initialData.salesResultAmount) : undefined,
      customerForecastAmount: initialData.customerForecastAmount ? Number(initialData.customerForecastAmount) : undefined,
      forecastAccuracy: initialData.forecastAccuracy ? Number(initialData.forecastAccuracy) : undefined,
    };
    return res;
  };
}
